// AWS Amplify configuration for shared use
const awsconfig = {
    Auth: {
        Cognito: {
            region: 'ap-south-1',
            App_ID: '7pqg44g1idn6ek5kntdk2d637v',
            userPoolId: 'ap-south-1_nlPa0vfEw',
            userPoolClientId: '6ahelt4jn8e145jnasdkjfuj3o',
            identityPoolId: 'ap-south-1:1608bbc3-e022-407f-9a05-07777b82e65c',
            allowGuestAccess: false,
            signUpVerificationMethod: 'code',
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            loginWith: {
                // OPTIONAL - Hosted UI configuration
                oauth: {
                    domain: 'https://ap-south-1nlpa0vfew.auth.ap-south-1.amazoncognito.com',
                    scopes: [
                        'phone',
                        'email',
                        'profile',
                        'openid',
                        'aws.cognito.signin.user.admin'
                    ],
                    redirectSignIn: ['http://localhost:3000/'],
                    redirectSignOut: ['http://localhost:3000/'],
                    responseType: 'token' // or 'token', note that REFRESH token will only be generated when the responseType is code
                }
            }
        }
    },
    Storage: {
        S3: {
            region: 'ap-south-1',
            bucket: 'image-bucket-nexiantian',
            dangerouslyConnectToHttpEndpointForTesting: false,
            defaultAccessLevel: "public"
        }
    }
};

export default awsconfig;

